import React from "react";

export default function Impresszum() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-4xl mx-auto bg-[#161616] backdrop-blur-xl rounded-2xl shadow-2xl border border-white/[0.08] overflow-hidden">
          <div className="p-8">
            <div className="text-center mb-8">
              <h1 className="text-3xl font-bold text-white mb-4">📄 Impresszum</h1>
              <div className="w-24 h-1 bg-gradient-to-r from-[#e31937] to-[#b40000] mx-auto rounded-full"></div>
            </div>

            <div className="space-y-8 text-gray-300">
              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <h2 className="text-xl font-bold text-white mb-4">Üzemeltető</h2>
                <div className="space-y-2">
                  <p><span className="font-semibold text-white">Cégnév:</span> HOPPX LTD</p>
                  <p><span className="font-semibold text-white">Rövidített elnevezés:</span> HOPPX LTD</p>
                  <p><span className="font-semibold text-white">Székhely:</span> 20-22 Wenlock Road, London N1 7GU, Egyesült Királyság</p>
                  <p><span className="font-semibold text-white">Cégjegyzékszám:</span> 10346107</p>
                  <p><span className="font-semibold text-white">Adószám:</span> 19867 21551</p>
                  <p><span className="font-semibold text-white">Képviselő neve:</span> Kollár István Antal</p>
                </div>
              </div>

              <div className="bg-white/5 rounded-xl p-6 border border-white/10">
                <h2 className="text-xl font-bold text-white mb-4">Elérhetőség</h2>
                <div className="space-y-2">
                  <p><span className="font-semibold text-white">E-mail:</span> <a href="mailto:hoppxplatform@gmail.com" className="text-[#e31937] hover:text-[#b40000] transition-colors">hoppxplatform@gmail.com</a></p>
                  <p><span className="font-semibold text-white">Weboldal:</span> <a href="https://hopphomes.hu" target="_blank" rel="noopener noreferrer" className="text-[#e31937] hover:text-[#b40000] transition-colors">https://hopphomes.hu</a></p>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <a 
                href="/"
                className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#e31937] to-[#b40000] hover:from-[#b40000] hover:to-[#8b0000] text-white font-semibold rounded-lg transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                Vissza a főoldalra
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
